module.exports = __webpack_public_path__ + "img/product_86.d1a0feb.webp";